module.exports = __webpack_public_path__ + "images/plan-2d-3a7f003038cd825d3048eb62dd874707.svg";